const PAIR_DELIMITER = '/';
const KEY_VALUE_DELIMITER = ':';
const HASH_PREFIX = '#!';

var $ = require('jquery'),
	KEYS = require('model/keys'),
	pubsub = require('events/pubsub'),
	oldHash = window.location.hash ? window.location.hash.split(HASH_PREFIX)[1] : null,
	browser = new (require('ua-parser-js'))().getBrowser(),
	DataTypes = require('./dataTypes').hash,
	_ = require('underscore');

function getKeyUsePushState(key) {
	if (!(key in KEYS)) {
		throw new Error('Key "' + key + '" not registered in keys.js!');
	}

	var rec = KEYS[key];

	return typeof rec !== 'string' && rec.pushState;
}

function getKeyDataType(key) {
	var rec = KEYS[key];

	if (!rec) {
		return undefined;
	}

	return rec.type;
}

function getKeySerializer(key) {
	// Check if we have custom serializer for type
	var dataType = getKeyDataType(key);
	if (dataType && typeof dataType === 'string' && DataTypes[dataType] && DataTypes[dataType].serialize) {
		return DataTypes[dataType].serialize;
	}

	return value => encodeURIComponent(value);
}

function getKeyDeserializer(key) {
	// Check if we have custom serializer for type
	var dataType = getKeyDataType(key);
	if (dataType) {
		// Used for constructor passed as type.
		if (typeof dataType === 'function') {
			return dataType;
		}
		// Custom from dataTypes file for hash store
		else if (DataTypes[dataType] && DataTypes[dataType].deserialize) {
			return DataTypes[dataType].deserialize;
		}
	}

	// Default to decoding value
	return value => decodeURIComponent(value);
}

function deserialize(hash = window.location.hash) {
	let hashState = {};

	if (hash) {
		if (hash.startsWith(HASH_PREFIX)) {
			hash = hash.substring(2);
		}
		hashState = hash.split(PAIR_DELIMITER).reduce((acc, pair) => {
			const [key, ...values] = pair.split(KEY_VALUE_DELIMITER);
			if (values.length > 0) {
				const deserializer = getKeyDeserializer(key);
				acc[key] = deserializer(values.join(KEY_VALUE_DELIMITER));
			}

			return acc;
		}, {});
	}
	return hashState;
}

function hashChangeHandler(data, oldData) {
	var changedKeys = [],
		oldPairsMap = {},
		i,
		l,
		oldHashTemp = '';

	if (oldHash) {
		oldPairsMap = deserialize(oldHash);
	}

	oldHashTemp = oldHash;
	oldHash = window.location.hash ? window.location.hash.split(HASH_PREFIX)[1] : null;

	var hashState = deserialize();

	for (var newKey in hashState) {
		if (!_.isEqual(oldPairsMap[newKey], hashState[newKey])) {
			changedKeys.push(newKey);
		}
	}

	for (var key in oldPairsMap) {
		if (!(key in hashState)) {
			changedKeys.push(key);
		}
	}

	if (changedKeys.length || (oldData && !oldData.p)) {
		let p = window.location.pathname;
		oldData = _.assign(oldData || { p }, {
			h: oldHashTemp
		});
		let updatedData = _.assign(data || { p }, {
			h: window.location.hash
		});

		if (!oldData.h) {
			oldData = null;
		}
		if (!updatedData.h) {
			updatedData = null;
		}

		pubsub.publish('hash-store-update', updatedData, oldData);
	}
	for (i = 0, l = changedKeys.length; i < l; i++) {
		pubsub.publish('store-changed', {
			key: changedKeys[i],
			value: hashState[changedKeys[i]]
		});
	}
}

$(document).on('click', 'a', function (e) {
	if (!e.originalEvent.defaultPrevented) {
		let href = this.href;
		let hash = this.hash;
		let path = this.pathname;
		let windowPath = window.location.pathname;
		let routeChange = path !== windowPath;

		// IE11 will not fire "hashchange" event when an anchor tag with a hash href is clicked
		// No browser will fire "hashchange" event when an anchor tag with no hash is clicked
		if (href && path !== '/logout' && !routeChange && (!hash || (browser.name === 'IE' && browser.version === '11.0'))) {
			let oldData = {
				p: window.location.pathname
			};
			let updatedData = {
				p: path
			};
			setTimeout(() => {
				hashChangeHandler(updatedData, oldData);
			}, 0);
		}
	}
});

window.addEventListener('hashchange', () => {
	hashChangeHandler();
});

pubsub.subscribe('route-changing', function (data, oldData) {
	setTimeout(() => hashChangeHandler(data, oldData), 0);
});

module.exports = {
	deserialize,

	forceReplaceState: false,

	get: function (key) {
		return deserialize()[key];
	},

	set: function (pairs, value) {
		var push = false;

		if (typeof pairs === 'string') {
			var temp = pairs;

			pairs = {};

			pairs[temp] = value;
		}

		var hashState = deserialize(),
			hash = '',
			changed = [];

		for (var key in hashState) {
			if (!(key in pairs)) {
				let serializer = getKeySerializer(key);
				hash += key + KEY_VALUE_DELIMITER + serializer(hashState[key]) + PAIR_DELIMITER;
			}
		}

		for (var k in pairs) {
			if (!_.isEqual(pairs[k], hashState[k]) && !(typeof hashState[k] === 'undefined' && pairs[k] === null)) {
				changed.push({
					key: k,
					value: pairs[k]
				});

				// if any changed keys use push state and existed before, then use push
				// if the key is being set the first time we don't want to use push
				// because then the initialization of tab-manager becomes part of the
				// back history, clicking back causes it to re-initialize and the back
				// button appears to break.
				//
				// Ensuring we only use push for changed (not new) hash states fixes this
				if (getKeyUsePushState(k) && typeof hashState[k] !== 'undefined') {
					push = true;
				}
			}

			let serializer = getKeySerializer(k);

			// Do not add null / undefined to hash
			if (typeof pairs[k] !== 'undefined' && pairs[k] !== null) {
				hash += k + KEY_VALUE_DELIMITER + serializer(pairs[k]) + PAIR_DELIMITER;
			}
		}

		if (this.forceReplaceState) {
			push = false;
		}

		if (hash !== window.location.hash.substring(2)) {
			let p = window.location.pathname;
			let oldData = {
				p,
				h: window.location.hash
			};
			let updatedData = {
				p,
				h: HASH_PREFIX + hash
			};
			if (!oldData.h) {
				oldData = null;
			}
			if (!hash) {
				updatedData = null;
			}
			setTimeout(() => pubsub.publish('hash-store-update', updatedData, oldData), 0);

			if (push) {
				history.pushState(null, null, HASH_PREFIX + hash);
			} else {
				history.replaceState(null, null, HASH_PREFIX + hash);
			}

			oldHash = window.location.hash ? window.location.hash.split(HASH_PREFIX)[1] : null;
		}

		return changed;
	},

	remove: function (key) {
		var hashState = deserialize(),
			hash = '',
			changed = false;

		for (var k in hashState) {
			let serializer = getKeySerializer(k);
			if (k !== key) {
				hash += k + KEY_VALUE_DELIMITER + serializer(hashState[k]) + PAIR_DELIMITER;
			} else {
				changed = true;
			}
		}

		if (hash !== window.location.hash.substring(2)) {
			history.replaceState(null, null, HASH_PREFIX + hash);

			oldHash = window.location.hash ? window.location.hash.split(HASH_PREFIX)[1] : null;
		}

		return changed;
	}
};
